import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Avtaler } from 'src/app/services/avtale/avtale.types';
import { Fakturaanlegg } from 'src/app/services/faktura/faktura.types';
import { Anlegg } from 'src/app/services/forbruk/forbruk.types';

@Component({
  selector: 'app-anlegg',
  templateUrl: './anlegg.component.html',
  styleUrls: ['./anlegg.component.scss']
})
export class AnleggComponent {
  @Input() _showAnleggsliste: boolean;
  @Input() valgtAnlegg: Anlegg | Fakturaanlegg;
  @Input() anleggList: (Anlegg | Fakturaanlegg)[];
  @Input() anleggIsInactive: (
    anlegg: Anlegg | Fakturaanlegg,
    avtaler?: Avtaler[]
  ) => boolean;
  @Input() mineAvtaler: Avtaler[];
  @Input() showMPID: boolean = false;
  @Output() outAnlegg = new EventEmitter<Anlegg | Fakturaanlegg>();

  constructor() {}

  emitAnlegg(anlegg: Anlegg | Fakturaanlegg) {
    this.outAnlegg.emit(anlegg);
  }

  showMpid(adr: Anlegg | Fakturaanlegg) {
    return this.showMPID && adr['mpid'] ? (adr as Fakturaanlegg)?.mpid : '';
  }
}
